import React from 'react'
import CommonAttributes from './CommonAttributes';
import TargetUniqueAttributes from './TargetUniqueAttributes';
import SourceUniqueAttributesTable from './SourceUniqueAttributesTable';

type TabGroupProps = {
    activeTabIndex: number;
    payload: TRecategorizePayload;
    setPayload: React.Dispatch<React.SetStateAction<TRecategorizePayload>>
    recategorizationResponse: RecategorizationResponse | undefined;
    setAttributeValueData: React.Dispatch<React.SetStateAction<AttributeValueMapping | null>>;
}

const TabContent = ({ activeTabIndex, payload, setPayload, recategorizationResponse, setAttributeValueData }: TabGroupProps) => {

    switch (activeTabIndex) {
        case 0:
            return <CommonAttributes recategorizationResponse={recategorizationResponse} payload={payload} setPayload={setPayload} />;
        case 1:
            return <SourceUniqueAttributesTable payload={payload} setPayload={setPayload} recategorizationResponse={recategorizationResponse} setAttributeValueData={setAttributeValueData} />;
        case 2:
            return <TargetUniqueAttributes payload={payload} recategorizationResponse={recategorizationResponse} />;
        default:
            return null;
    }
}
export default TabContent